import FullCalendar from "@fullcalendar/react";
import React, { useEffect, useRef, useState } from "react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import axiosInstance from "../../../../Services/axiosCommon";
import { useParams } from "react-router-dom";

function TimeSheet() {
      const { ViewEmployeeId } = useParams();
    const [employeeAttendes,setEmployeeAttendes] = useState([]);
  
  const [currentMonth, setCurrentMonth] = useState(new Date().getMonth() + 1);
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  const calendarRef = useRef(null);
  // Generate an array of years for the dropdown
  const generateYears = () => {
    const currentYear = new Date().getFullYear();
    return Array.from({ length: 21 }, (_, i) => currentYear - 10 + i);
  };
  const [employeenew, setEmployeenew] = useState("");

  async function getMembersByProject(number) {
    await axiosInstance

      .get(`/Attendance/employee/${ViewEmployeeId}/month/${currentMonth}/year/${currentYear}`)
      .then((res)=>{
        res?.data?.data && setEmployeeAttendes(res?.data?.data)
        setEmployeenew(res?.data?.data?.attendances)
      }).catch((error)=>{
        if (error.response && error.response.status === 404) {
          setEmployeeAttendes([]);
        }
        console.log(error);
      })
  }


  useEffect(() => {
      getMembersByProject(ViewEmployeeId);
  }, [currentMonth,currentYear,ViewEmployeeId]);

  // Handle dropdown changes
  const handleDropdownChange = (e) => {
    const { name, value } = e.target;
    if (name === "month") {
      setCurrentMonth(parseInt(value, 10));
    } else if (name === "year") {
      setCurrentYear(parseInt(value, 10));
    }
  };

  // Navigate to the selected month and year
  useEffect(() => {
    if (calendarRef.current) {
      const calendarApi = calendarRef.current.getApi();
      calendarApi.gotoDate(
        `${currentYear}-${String(currentMonth).padStart(2, "0")}`
      );
    }
  }, [currentMonth, currentYear]);
  let eventsStatus = [
    {
      label: "Present",
      textColor: "text-[#FF0000]",
      bgColor: "bg-[#FF0000]",
    },
    {
      label: "Absent",
      textColor: "text-[#008000]",
      bgColor: "bg-[#008000]",
    },
    {
      label: "vacation",
      textColor: "text-[#3caae8]",
      bgColor: "bg-[#3caae8]",
    },
  ];

  function prevMonth() {
    if (currentMonth == 1) {
      setCurrentMonth(12);
      setCurrentYear(currentYear - 1);
    } else {
      setCurrentMonth(currentMonth - 1);
    }
  }

  function nextMonth() {
    if (currentMonth == 12) {
      setCurrentMonth(1);
      setCurrentYear(currentYear + 1);
    } else {
      setCurrentMonth(currentMonth + 1);
    }
  }
  return (
    <div className=" w-full h-full py-3">
      <div className="header flex justify-between items-center px-4 py-1">
        <div className=" xl:flex items-center gap-1">
          {eventsStatus.map((status, index) => (
            <p
              key={index}
              className={`flex items-center text-[10px] 2xl:text-xs px-1 2xl:px-[10px] py-2 font-medium ${status.textColor} rounded-xl`}
            >
              <div
                className={`w-3 h-3 rounded-full ${status.bgColor} mx-2`}
              ></div>
              {status.label}
            </p>
          ))}
        </div>
        <div className=" xl:flex items-center gap-1 2xl:gap-5 text-[10px] 2xl:text-xs font-semibold">
            <div className="py-1">Working Days : 0</div>
            <div className="py-1">Leave : 0</div>
            <div className="py-1">Vacation : 0</div>
            <div className="py-1">Holiday : 0</div>
        </div>

        <div className="flex items-center gap-2">
        <button onClick={prevMonth} className=" font-bold text-xl">
        <svg
            width="7"
            height="12"
            viewBox="0 0 10 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.39019 1.21179C9.61683 1.43849 9.74414 1.74592 9.74414 2.06648C9.74414 2.38703 9.61683 2.69446 9.39019 2.92116L3.40621 8.90514L9.39019 14.8891C9.6104 15.1171 9.73225 15.4225 9.7295 15.7395C9.72674 16.0564 9.59961 16.3596 9.37547 16.5838C9.15133 16.8079 8.84813 16.935 8.53116 16.9378C8.2142 16.9406 7.90883 16.8187 7.68083 16.5985L0.842158 9.75983C0.615527 9.53313 0.488212 9.2257 0.488212 8.90514C0.488212 8.58459 0.615527 8.27716 0.842158 8.05046L7.68083 1.21179C7.90753 0.985163 8.21496 0.857849 8.53551 0.857849C8.85607 0.857849 9.1635 0.985163 9.39019 1.21179Z"
              fill="#000000"
            />
          </svg>
        </button>
        <div>
          <select
            name="month"
            value={currentMonth}
            onChange={handleDropdownChange}
            className="border-none rounded p-1 outline-none text-[11px] 2xl:text-xs"
          >
            {[
              "January",
              "February",
              "March",
              "April",
              "May",
              "June",
              "July",
              "August",
              "September",
              "October",
              "November",
              "December",
            ].map((month, index) => (
              <option key={index} value={index + 1} className=" text-xs ">
                {month}
              </option>
            ))}
          </select>
        </div>
        <div>
          <select
            name="year"
            value={currentYear}
            onChange={handleDropdownChange}
            className="border-none outline-none rounded p-1 text-xs "
          >
            {generateYears().map((year) => (
              <option key={year} value={year} className=" text-[11px] 2xl:text-xs">
                {year}
              </option>
            ))}
          </select>
        </div>
        <button onClick={nextMonth} className=" font-bold text-2xl">
        <svg
            width="7"
            height="12"
            viewBox="0 0 10 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.877383 16.5839C0.650752 16.3572 0.523438 16.0497 0.523438 15.7292C0.523438 15.4086 0.650752 15.1012 0.877384 14.8745L6.86137 8.89051L0.877385 2.90652C0.657177 2.67853 0.535327 2.37316 0.538082 2.05619C0.540836 1.73923 0.667974 1.43602 0.892111 1.21188C1.11625 0.987747 1.41945 0.860611 1.73642 0.857857C2.05338 0.855103 2.35875 0.976952 2.58675 1.19716L9.42542 8.03583C9.65205 8.26253 9.77937 8.56996 9.77937 8.89051C9.77937 9.21106 9.65205 9.51849 9.42542 9.74519L2.58675 16.5839C2.36005 16.8105 2.05262 16.9378 1.73207 16.9378C1.41151 16.9378 1.10408 16.8105 0.877383 16.5839Z"
              fill="#000000"
            />
          </svg>
          </button>
        </div>
      </div>
      <div className=" w-full h-[calc(100%-3rem)] overflow-hidden mx-auto">
        <FullCalendar
          ref={calendarRef}
          plugins={[dayGridPlugin, interactionPlugin]}
          initialView="dayGridMonth"
          selectable
          editable
          headerToolbar={{
            start: "",
            center: "",
            end: "",
          }}
          height={"100%"}
          eventClick={(e) => {}}
          resourceAreaWidth="100%"
          resourceAreaHeight="20%"
          fixedWeekCount={false}
          // showNonCurrentDates={false}
        />
      </div>
    </div>
  );
}

export default TimeSheet;
